var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09 19H16.91C18.0643 19 19 17.8588 19 16.4512C19 15.0436 18.0643 13.9024 16.91 13.9024H2.09C0.93575 13.9024 0 15.0436 0 16.4512C0 17.8588 0.93575 19 2.09 19ZM5.89 12.0488H16.91C18.0643 12.0488 19 10.9076 19 9.5C19 8.09238 18.0643 6.95122 16.91 6.95122H5.89C4.73575 6.95122 3.8 8.09238 3.8 9.5C3.8 10.9076 4.73575 12.0488 5.89 12.0488ZM9.69 5.09756H16.91C18.0643 5.09756 19 3.9564 19 2.54878C19 1.14116 18.0643 2.38419e-07 16.91 2.38419e-07H9.69C8.53575 2.38419e-07 7.6 1.14116 7.6 2.54878C7.6 3.9564 8.53575 5.09756 9.69 5.09756Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.c601ca65a8581b4c4b9be51083daa8c0.svg";
export { ForwardRef as ReactComponent };